import React, { forwardRef } from "react";
import { BSDiv } from "../../types";

export const Progress = forwardRef<HTMLDivElement, BSDiv>(
  ({ className = "", children, ...props }, ref) => (
    <div className={`progress ${className}`} {...props} ref={ref}>
      {children}
    </div>
  )
);